<template>
  <v-container fluid>
    <v-row class="mx-1 px-1">
      <v-col cols="12">
        <h2 class="primary--text">Registo de Material</h2>

        <v-breadcrumbs large :items="crumbs" divider="/" class="pl-0" />

        <v-progress-linear
          v-if="isLoading"
          class="global-loader"
          indeterminate
        />

        <v-divider class="mb-12" />

        <v-container fluid>
          <validation-observer ref="form" v-slot="{ invalid }">
            <v-form @submit.prevent="submit">
              <v-row>
                <v-col cols="12" md="4">
                  <validation-provider v-slot="{ errors }" name="Obras" rules="required">
                    <v-autocomplete
                      v-model="fields.obra_id"
                      :items="obras"
                      outlined
                      dense
                      :item-text="item => item.Codigo + ' - ' + item.Descricao"
                      item-value="Id"
                      :error-messages="errors"
                      label="Obras *"
                      @change="changeWork"
                    />
                  </validation-provider>
                </v-col>

                <v-col cols="12" md="4" v-if="fields.obra_id != null && hideFrentes === false">
                  <validation-provider v-slot="{ errors }" name="FrenteObra" rules="|">
                    <v-autocomplete
                      v-model="fields.frente_id"
                      :items="frentes_obra"
                      outlined
                      dense
                      clearable
                      :item-text="item => item.Descricao"
                      item-value="ID"
                      :error-messages="errors"
                      label="Frente Obra"
                      @change="changedFrenteObra"
                    />
                  </validation-provider>
                </v-col>

                <v-col cols="12" md="4" v-if="classeNeeded">
                  <validation-provider v-slot="{ errors }" name="Classe" rules="|">
                    <v-autocomplete
                      v-model="fields.classe_id"
                      :items="classes"
                      outlined
                      clearable
                      dense
                      :item-text="item => item.Descricao"
                      item-value="ID"
                      :error-messages="errors"
                      label="Classe"
                      @change="changedClass"
                    />
                  </validation-provider>
                </v-col>
              </v-row>

              <v-row v-if="showContent">
                <v-card class="elevation-0" width="100%">
                  <v-card-title class="primary white--text d-flex align-center justify-space-between">
                    <span class="text-subtitle-1 font-weight-bold">Materiais</span>

                    <v-btn
                      small
                      color="warning"
                      class="white--text"
                      @click="openNewMaterialDialog"
                    >
                      <v-icon left small>mdi-plus</v-icon>
                      Adicionar
                    </v-btn>
                  </v-card-title>

                  <v-card-text class="mt-4">
                    <v-text-field
                      v-model="searchMateriais"
                      label="Pesquisar material"
                      dense
                      outlined
                      clearable
                      prepend-inner-icon="mdi-magnify"
                      hide-details
                      @input="pageMateriaisObra = 1"
                    />

                    <v-data-table
                      :headers="headersMateriaisObra"
                      :items="filteredMateriaisObra"
                      :search="searchMateriais"
                      :page.sync="pageMateriaisObra"
                      :items-per-page="itemsPerPageMateriaisObra"
                      :loading="isLoading"
                      loading-text="A carregar materiais..."
                      no-data-text="Ainda não existem materiais para esta seleção."
                      no-results-text="Nenhum material encontrado para a pesquisa."
                      class="elevation-1 rounded-lg mt-6"
                    >
                      <template v-slot:item="{ item }">
                        <tr :class="item.em_stock ? 'blue lighten-5' : ''">
                          <td>
                            {{ (item.obra && item.obra.Codigo) ? item.obra.Codigo : getObra() }}
                          </td>
                          <td>
                            {{ item.frente_nome ? item.frente_nome : '-' }}
                          </td>
                          <td>
                            {{ item.classe_nome ? item.classe_nome : '-' }}
                          </td>
                          <td>
                            <div class="d-flex flex-column">
                              <div class="font-weight-medium">
                                {{ item.artigo }} - {{ item.descricao }}
                              </div>
                              <div class="caption grey--text" v-if="item.em_stock">
                                Em stock
                              </div>
                            </div>
                          </td>
                          <td class="text-center">
                            <v-chip small outlined>{{ item.unidade_base }}</v-chip>
                          </td>
                          <td class="text-center">
                            <v-tooltip top v-if="!item.em_stock">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  icon
                                  color="error"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="deleteMaterial(item)"
                                >
                                  <v-icon small>mdi-delete</v-icon>
                                </v-btn>
                              </template>
                              <span>Remover material</span>
                            </v-tooltip>

                            <v-tooltip top v-else>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn icon disabled v-bind="attrs" v-on="on">
                                  <v-icon small>mdi-lock</v-icon>
                                </v-btn>
                              </template>
                              <span>Não pode remover (em stock)</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-row>

              <v-btn rounded class="success mt-4" :disabled="invalid" type="submit">
                Gravar
              </v-btn>
            </v-form>
          </validation-observer>
        </v-container>
      </v-col>
    </v-row>

    <SuccessSnackbar message="Materiais gravados com sucesso" v-model="success" />

    <!-- DIALOG -->
    <v-dialog v-model="newMaterial.showDialog" max-width="900px" persistent>
      <v-card class="rounded-xl elevation-4 d-flex flex-column" style="max-height: 80vh;">
        <!-- HEADER -->
        <v-card-title class="primary white--text rounded-t-xl">
          <div class="d-flex align-center justify-space-between flex-grow-1">
            <span class="text-subtitle-1 font-weight-bold">Adicionar material</span>

            <v-btn icon small class="white--text" @click="newMaterial.showDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <!-- CONTEXTO (OBRA/ FRENTE/ CLASSE) -->
        <v-card-text class="pb-0">
          <v-row>
            <v-col cols="12" md="4">
              <validation-provider v-slot="{ errors }" name="ObraDialog" rules="required">
                <v-autocomplete
                  v-model="dialogFields.obra_id"
                  :items="obras"
                  outlined
                  dense
                  :item-text="item => item.Codigo + ' - ' + item.Descricao"
                  item-value="Id"
                  :error-messages="errors"
                  label="Obra *"
                  :disabled="dialogObraDisabled"
                  @change="onDialogWorkChange"
                />
              </validation-provider>
            </v-col>

            <v-col cols="12" md="4" v-if="dialogFields.obra_id && dialogHideFrentes === false">
              <validation-provider v-slot="{ errors }" name="FrenteDialog" rules="|">
                <v-autocomplete
                  v-model="dialogFields.frente_id"
                  :items="dialogFrentes"
                  outlined
                  dense
                  :item-text="item => item.Descricao"
                  clearable
                  item-value="ID"
                  :error-messages="errors"
                  label="Frente Obra (opcional)"
                  :disabled="dialogFrenteDisabled"
                  @change="onDialogFrenteChange"
                />
              </validation-provider>
            </v-col>

            <v-col cols="12" md="4" v-if="dialogClasseNeeded">
              <validation-provider v-slot="{ errors }" name="ClasseDialog" rules="|">
                <v-autocomplete
                  v-model="dialogFields.classe_id"
                  :items="dialogClasses"
                  outlined
                  clearable
                  dense
                  :item-text="item => item.Descricao"
                  item-value="ID"
                  :error-messages="errors"
                  label="Classe (opcional)"
                  :disabled="dialogClasseDisabled"
                  @change="onDialogClasseChange"
                />
              </validation-provider>
            </v-col>
          </v-row>

          <v-divider class="mt-2" />
        </v-card-text>

        <!-- PESQUISA -->
        <v-card-text class="pb-0">
          <v-row>
            <v-col cols="12" md="10">
              <v-text-field
                v-model="search"
                label="Escolha o material"
                dense
                outlined
                hint="Escreva o material e clique em procurar"
                persistent-hint
                clearable
                prepend-inner-icon="mdi-magnify"
                class="mt-4"
                @keyup.enter="loadMaterials"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-btn block class="success mt-4" @click="loadMaterials">
                <v-icon left>mdi-magnify</v-icon>
                Procurar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- LISTA -->
        <v-card-text class="pt-2 pb-0 flex-grow-1" style="overflow-y: auto;">
          <v-row v-if="!isLoading">
            <v-col cols="12">
              <v-simple-table class="d-none d-lg-block">
                <template v-slot:default>
                  <thead class="primary">
                    <tr>
                      <th width="65%" class="text-left white--text text-caption font-weight-bold px-4">
                        Material
                      </th>
                      <th width="15%" class="text-center white--text text-caption font-weight-bold">
                        Unidade
                      </th>
                      <th width="10%" class="text-center white--text text-caption font-weight-bold">
                        Selecionar
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-if="paginatedMateriais.length === 0">
                      <td colspan="3" class="text-center grey--text py-6">
                        Nenhum material encontrado. Ajuste a pesquisa.
                      </td>
                    </tr>

                    <tr v-for="item in paginatedMateriais" :key="item.artigo">
                      <td class="px-4">
                        {{ item.artigo }} - {{ item.descricao }}
                      </td>
                      <td class="text-center">
                        {{ item.unidade_base }}
                      </td>
                      <td class="text-center">
                        <v-switch v-model="item.selected" inset hide-details class="mb-4" />
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>

          <!-- Paginação -->
          <v-row v-if="totalPagesMateriais > 1" justify="center" class="mt-4 mb-2">
            <v-col cols="12" class="text-center">
              <v-pagination
                v-model="pageMateriais"
                :length="totalPagesMateriais"
                circle
                total-visible="7"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <!-- FOOTER -->
        <v-divider />
        <v-card-actions class="justify-center py-3">
          <v-btn class="success px-8" large @click="adicionarMaterial" :disabled="isDialogSaveDisabled">
            <v-icon left>mdi-content-save</v-icon>
            Gravar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import FrenteObra from "@/api/FrenteObra.js"
import Classe from "@/api/Classe.js"
import Obra from "@/api/Obra.js"
import Artigos from "@/api/Artigos.js"
import Materiais from "@/api/Materiais.js"
import dayjs from "dayjs"
import SuccessSnackbar from "@/components/UI/Snackbars/SuccessSnackbar"

export default {
  name: "AddMaterial",
  components: {
    SuccessSnackbar
  },
  data() {
    return {
      hideFrentes: false,
      frentes_obra: [],
      classes: [],
      materiais: [],
      materiais_remote: [],
      obras: [],
      success: false,
      unidades: [],
      showContent: false,
      classeNeeded: false,
      isLoading: true,
      model: null,
      search: "",
      searchMateriais: "",
      pageMateriaisObra: 1,
      itemsPerPageMateriaisObra: 10,

      headersMateriaisObra: [
        { text: "Obra", value: "obra", width: "15%" },
        { text: "Frente Obra", value: "frente_nome", width: "20%" },
        { text: "Classe", value: "classe_nome", width: "20%" },
        { text: "Material", value: "material", width: "35%" },
        { text: "Unidade", value: "unidade_base", align: "center", width: "5%" },
        { text: "Opções", value: "actions", align: "center", width: "5%", sortable: false }
      ],

      fields: {
        frente_id: null,
        classe_id: null,
        obra_id: null,
        materiais: []
      },

      newMaterial: {
        showDialog: false,
        material_id: null,
        unidade: null
      },

      dialogFields: {
        obra_id: null,
        frente_id: null,
        classe_id: null
      },
      dialogFrentes: [],
      dialogClasses: [],
      dialogHideFrentes: false,
      dialogClasseNeeded: false,

      pageMateriais: 1,
      itemsPerPage: 10
    }
  },
  mounted() {
    if (!this.$store.getters.hasPermission(["super", "materials.create"])) {
      this.$router.push("/forbidden")
    }
    this.fillBaseData()
  },
  computed: {
    dialogObraDisabled() {
      return true
    },
    dialogFrenteDisabled() {
      return !!this.fields.frente_id
    },
    dialogClasseDisabled() {
      return !!this.fields.classe_id
    },

    isDialogSaveDisabled() {
      if (!this.dialogFields.obra_id) return true
      return !this.materiais_remote.some(m => m.selected)
    },

    getMateriais() {
      this.materiais_remote = []

      this.materiais.forEach(element => {
        this.materiais_remote.push({
          artigo: element.artigo,
          descricao: element.descricao,
          unidade_base: element.unidade_base,
          selected: false
        })
      })

      return this.materiais_remote
    },

    paginatedMateriais() {
      const start = (this.pageMateriais - 1) * this.itemsPerPage
      const end = start + this.itemsPerPage
      return this.getMateriais.slice(start, end)
    },

    totalMateriais() {
      return this.getMateriais.length
    },

    totalPagesMateriais() {
      return Math.max(1, Math.ceil(this.totalMateriais / this.itemsPerPage) || 1)
    },

    filteredMateriaisObra() {
      if (!this.searchMateriais) return this.fields.materiais

      const term = this.searchMateriais.toLowerCase()

      return this.fields.materiais.filter(m => {
        const artigo = (m.artigo || "").toString().toLowerCase()
        const descricao = (m.descricao || "").toLowerCase()
        return artigo.includes(term) || descricao.includes(term)
      })
    },

    crumbs() {
      return [
        {
          text: "Registo de Material",
          disabled: true,
          to: "#",
          exact: true
        }
      ]
    }
  },
  methods: {
    resolveFrenteNomeById(id) {
      const list = (this.dialogFrentes && this.dialogFrentes.length) ? this.dialogFrentes : this.frentes_obra
      const f = (list || []).find(x => x.ID === id)
      return f ? f.Descricao : "-"
    },
    resolveClasseNomeById(id) {
      const list = (this.dialogClasses && this.dialogClasses.length) ? this.dialogClasses : this.classes
      const c = (list || []).find(x => x.ID === id)
      return c ? c.Descricao : "-"
    },

    async openNewMaterialDialog() {
      // obra no dialog = sempre a do ecrã principal
      this.dialogFields.obra_id = this.fields.obra_id

      // herda frente/classe se já existirem no principal
      this.dialogFields.frente_id = this.fields.frente_id
      this.dialogFields.classe_id = this.fields.classe_id

      // carrega frentes/classes para essa obra
      await this.loadDialogContextForObra()

      // se já veio frente (do principal), carrega classes dessa frente
      if (this.dialogFields.frente_id) {
        await this.onDialogFrenteChange()
      }

      this.newMaterial.showDialog = true
    },

    async loadDialogContextForObra() {
      this.dialogFrentes = []
      this.dialogClasses = []
      this.dialogHideFrentes = false
      this.dialogClasseNeeded = false

      let obraPai = null
      this.obras.forEach(o => {
        if (o.Id === this.dialogFields.obra_id) obraPai = o.Codigo
      })

      const respFrentes = await FrenteObra.all(obraPai)
      this.dialogFrentes = respFrentes.data || []

      // se não tem frentes -> classes por obra
      if (this.dialogFrentes.length === 0) {
        const respClasses = await Classe.getClassesByObraPai(this.dialogFields.obra_id)
        this.dialogClasses = respClasses.data || []
        this.dialogHideFrentes = true
        this.dialogClasseNeeded = this.dialogClasses.length > 0
        return
      }

      // tem frentes -> classe depende da frente (só mostra depois de escolher frente)
      this.dialogHideFrentes = false
      this.dialogClasseNeeded = false
    },

    async onDialogWorkChange() {
      // obra normalmente está disabled; se um dia permitires mudar, isto atualiza contexto
      await this.loadDialogContextForObra()

      // se mudou obra, limpa frente/classe (a não ser que queiras reaproveitar)
      this.dialogFields.frente_id = null
      this.dialogFields.classe_id = null
      this.dialogClasseNeeded = false
      this.dialogClasses = []
    },

    async onDialogFrenteChange() {
      // frente é opcional
      if (!this.dialogFields.frente_id) {
        this.dialogClasses = []
        this.dialogClasseNeeded = false
        this.dialogFields.classe_id = null
        return
      }

      let frente = null
      this.dialogFrentes.forEach(f => {
        if (f.ID === this.dialogFields.frente_id) frente = f
      })
      if (!frente) return

      const resp = await Classe.getClasses({ SubEmp: frente.SubEmp })
      this.dialogClasses = resp.data || []
      this.dialogClasseNeeded = this.dialogClasses.length > 0

      // classe também é opcional, não auto-seleciono
      // se quiseres auto quando só 1, descomenta:
      // if (!this.dialogFields.classe_id && this.dialogClasses.length === 1) {
      //   this.dialogFields.classe_id = this.dialogClasses[0].ID
      // }
    },

    onDialogClasseChange() {
      // classe opcional, nada a fazer
    },

    getClasse() {
      let cod = "-"
      this.classes.forEach(element => {
        if (element.ID === this.fields.classe_id) cod = element.Descricao
      })
      return cod
    },

    getFrenteObra() {
      let cod = "-"
      this.frentes_obra.forEach(element => {
        if (element.ID === this.fields.frente_id) cod = element.Descricao
      })
      return cod
    },

    getObra() {
      let cod = "-"
      this.obras.forEach(element => {
        if (element.Id === this.fields.obra_id) cod = element.Codigo
      })
      return cod
    },

    loadMaterials() {
      Artigos.all({ search: this.search }).then(resp => {
        this.materiais = resp.data || []
        this.materiais_remote = this.materiais.map(element => ({
          artigo: element.artigo,
          descricao: element.descricao,
          unidade_base: element.unidade_base,
          selected: false
        }))
        this.pageMateriais = 1
      })
    },

    adicionarMaterial() {
      const existing = new Set((this.fields.materiais || []).map(m => m.artigo))

      const finalFrenteId = (this.fields.frente_id ?? this.dialogFields.frente_id ?? null)
      const finalClasseId = (this.fields.classe_id ?? this.dialogFields.classe_id ?? null)

      const finalFrenteNome = finalFrenteId ? this.resolveFrenteNomeById(finalFrenteId) : "-"
      const finalClasseNome = finalClasseId ? this.resolveClasseNomeById(finalClasseId) : "-"

      this.materiais_remote.forEach(element => {
        if (element.selected && !existing.has(element.artigo)) {
          this.fields.materiais.push({
            id: dayjs().unix(),
            artigo: element.artigo,
            descricao: element.descricao,
            unidade_base: element.unidade_base,
            em_stock: false,

            frente_id: finalFrenteId,
            classe_id: finalClasseId,
            frente_nome: finalFrenteNome,
            classe_nome: finalClasseNome
          })
          existing.add(element.artigo)
        }
      })

      this.success = true
      this.newMaterial.showDialog = false
    },

    // ----- MAIN FLOW -----
    changeWork() {
      let ObraPai = null
      this.obras.forEach(element => {
        if (element.Id === this.fields.obra_id) ObraPai = element.Codigo
      })

      FrenteObra.all(ObraPai).then(resp => {
        this.frentes_obra = resp.data || []

        if (this.frentes_obra.length === 0) this.classesPorObra()

        if (this.frentes_obra.length === 1) {
          this.fields.frente_id = this.frentes_obra[0].ID
          this.changedFrenteObra()
        }
      })

      this.loadTable()
      this.showContent = true
    },

    classesPorObra() {
      Classe.getClassesByObraPai(this.fields.obra_id).then(resp => {
        this.classes = resp.data || []
        this.hideFrentes = true
        this.classeNeeded = true

        if (this.classes.length === 1) {
          this.fields.classe_id = this.classes[0].ID
        }

        this.showContent = true
      })
    },

    deleteMaterial(item) {
      const idx = this.fields.materiais.findIndex(m => m.id === item.id)
      if (idx !== -1) this.fields.materiais.splice(idx, 1)
    },

    loadTable() {
      let classe = null
      this.classes.forEach(element => {
        if (element.ID === this.fields.classe_id) classe = element
      })

      let frente = null
      this.frentes_obra.forEach(element => {
        if (element.ID === this.fields.frente_id) frente = element
      })

      const data = {
        id_frente_obra: frente == null ? null : frente.SubEmpId,
        id_obra_classe: classe == null ? null : classe.ClasseId,
        obra_id: this.fields.obra_id
      }

      Materiais.getListMateriaisObra(data).then(resp => {
        this.fields.materiais = (resp.data || []).map(m => ({
          id: m.id || dayjs().unix(),
          artigo: m.artigo,
          descricao: m.descricao,
          unidade_base: m.unidade_base,
          em_stock: !!m.em_stock,
          obra: m.obra || null,
          frente_nome: m.frente_nome || (m.frente ? m.frente.Descricao : null),
          classe_nome: m.classe_nome || (m.classe ? m.classe.Descricao : null),
          obra_id: m.obra_id,
          frente_id: m.frente_id,
          classe_id: m.classe_id
        }))
        this.isLoading = false
      })
    },

    fillBaseData() {
      const data = { tipo: "O" }

      Obra.all(data).then(resp => {
        this.obras = resp.data || []

        let entrei = false
        if (this.$route.params.id !== undefined) {
          if (this.$route.params.id != null) {
            entrei = true
            this.fields.obra_id = this.$route.params.id
            this.changeWork()
          }
          entrei = true
        }

        if (!entrei) this.isLoading = false
      })
    },

    async changedFrenteObra() {
      // frente opcional: se limpou, limpa classes e reload table
      if (!this.fields.frente_id) {
        this.classes = []
        this.fields.classe_id = null
        this.classeNeeded = false
        this.loadTable()
        return
      }

      let frente = null
      this.frentes_obra.forEach(element => {
        if (element.ID === this.fields.frente_id) frente = element
      })

      if (frente != null) {
        const data = { SubEmp: frente.SubEmp }

        await Classe.getClasses(data).then(resp => {
          this.classes = resp.data || []
          if (this.classes.length === 1) {
            // não auto-seleciono, porque disseste que pode ser sem classe
            // se quiseres auto, mete:
            // this.fields.classe_id = this.classes[0].ID
          }
        })

        this.classeNeeded = this.classes.length > 0
        this.loadTable()
      }
    },

    changedClass() {
      this.loadTable()
    },

    submit() {
      let classe = null
      this.classes.forEach(element => {
        if (element.ID === this.fields.classe_id) classe = element
      })

      let frente = null
      this.frentes_obra.forEach(element => {
        if (element.ID === this.fields.frente_id) frente = element
      })

      const data = {
        frente_id: frente == null ? null : frente.SubEmpId,
        classe_id: classe == null ? null : classe.ClasseId,
        obra_id: this.fields.obra_id,
        materiais: this.fields.materiais
      }

      Materiais.create(data)
        .then(() => {
          this.success = true
          this.error = false
          this.loader = false
        })
        .catch(err => {
          if (err.response && err.response.status === 422) {
            this.$refs.pd.$refs.form.setErrors(err.response.data.errors)
          }

          this.success = false
          this.error = true
          this.error_message = err.response?.data?.message
          this.loader = false
        })
    }
  }
}
</script>
